module.exports = __webpack_public_path__ + "static/media/sultron.53aef9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/acaro_blanco_papa/preventiva/sultron.png
// module id = 1989
// module chunks = 3